import Swal from "sweetalert2";

// export const showAlert = (
//   text,
//   preConfirm,
//   confirmButtonText,
//   icon = "warning",
//   confirmBtnColor = "#d30b0b",
//   cancelBtnColor = "#757f91"
// ) => {
//   return Swal.fire({
//     text,
//     icon,
//     showCancelButton: true,
//     confirmButtonColor: confirmBtnColor,
//     cancelButtonColor: cancelBtnColor,
//     confirmButtonText,
//     showLoaderOnConfirm: true,
//     preConfirm,
//     allowOutsideClick: () => !Swal.isLoading(),
//   });
// };

export const showAlert = (
  text,
  preConfirm,
  confirmButtonText,
  onCancel,
  icon = "warning",
  confirmBtnColor = "#d30b0b",
  cancelBtnColor = "#757f91"
) => {
  return Swal.fire({
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: confirmBtnColor,
    cancelButtonColor: cancelBtnColor,
    confirmButtonText,
    showLoaderOnConfirm: true,
    preConfirm,
    allowOutsideClick: () => !Swal.isLoading(),
  }).then((result) => {
    if (result.isDismissed) {
      // This means the user clicked "Cancel" or dismissed the alert
      if (onCancel) onCancel(); // Call onCancel if provided
    }
  });
};
export const showAlertHtml = (
  html,
  preConfirm,
  confirmButtonText,
  icon = "warning",
  confirmBtnColor = "#d30b0b",
  cancelBtnColor = "#757f91"
) => {
  Swal.fire({
    html,
    icon,
    showCancelButton: true,
    confirmButtonColor: confirmBtnColor,
    cancelButtonColor: cancelBtnColor,
    confirmButtonText,
    showLoaderOnConfirm: true,
    preConfirm,
    allowOutsideClick: () => !Swal.isLoading(),
  });
};
